import { useSelector } from 'react-redux';

import { currentOpenChatSelector, isShowSubAgentChatListSelector, userIdSelector } from '../../../selectors';
import { EChatRole } from '../../../types/userData';

export const useOutcomingMessageStyle = (isOutcoming: boolean, messageUserId: number): boolean => {
  const userId = useSelector(userIdSelector);
  const { users = [] } = useSelector(currentOpenChatSelector) || {};
  const isShowSubAgentChatList = useSelector(isShowSubAgentChatListSelector);

  const currentUser = users.find(user => user.userId === userId);
  const messageUser = users.find(user => user.userId === messageUserId);

  // Если зашли за мастера считаем сообщения оппонента - исходящими
  if (currentUser?.chatRole === EChatRole.Master && messageUser?.chatRole === EChatRole.Opponent) {
    return true;
  }

  // Если мастер просматривает сообщения субагента считаем сообщения оппонента - исходящими
  if (isShowSubAgentChatList && messageUser?.chatRole === EChatRole.Opponent) {
    return true;
  }

  // Если зашли за оппонента считаем сообщения мастера - исходящими
  if (currentUser?.chatRole === EChatRole.Opponent && messageUser?.chatRole === EChatRole.Master) {
    return true;
  }

  return isOutcoming;
};
